/**
 * Fallback Event Component
 *
 * Renders unknown event types with basic information.
 * Used when no specific component exists for an event type.
 */

import { ActorName, InlineText, TimelineEvent } from '../components/shared';
import { useEventFormatters } from '../useEventFormatters';
import type { EventComponentProps } from './types';

export function FallbackEvent({ event }: EventComponentProps) {
  const { getActorInfo } = useEventFormatters();
  const actor = getActorInfo(event);

  // Format event type for display
  const eventTypeLabel = event.event_type_name
    .replace(/^ahoy_/, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

  const ariaLabel = `${actor.name}: ${eventTypeLabel}`;

  return (
    <TimelineEvent ariaLabel={ariaLabel}>
      <TimelineEvent.Icon event={event} />
      <TimelineEvent.Header timestamp={event.occurred_at}>
        <InlineText>
          <ActorName actor={actor} />: {eventTypeLabel}
        </InlineText>
      </TimelineEvent.Header>
    </TimelineEvent>
  );
}
